import { useRef } from 'react';

import { useEnv } from '@lib/components/envProvider';
import { getLogger } from '@lib/services/logger';
import { LogLevel } from '@lib/types';

export const useLogger = (prefix?: string, logLevelOverwrite?: LogLevel) => {
  const { logLevel } = useEnv();
  const { current: log } = useRef(getLogger(prefix, logLevelOverwrite || logLevel));

  // eslint-disable-next-line react-hooks/refs
  return log;
};
